/**
 * 初始化是否国际版变量，然后将其挂载到window上
 * 国际版测试站：https://open-x7game-com.msshuo.cn/
 * 国际版正式站：https://open.x7game.com/
 */
import x7url from '@/utils/x7url'
const getIsInternational = () => x7url.isForeign

export { getIsInternational }
